import { ProductTestResultPassFail, ProductTestResultYesNo } from "./types"

import type { FileTypeToChipMap } from "@/components/Tables/Aeros/hooks/useFileColumns"
import { FieldGroupEnum, ProductTestStatus } from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"

export const PRODUCT_TEST_STATUS_TO_LABEL = new Map<string, string>([
  [ProductTestStatus.Approved, "Approved"],
  [ProductTestStatus.OnHold, "On Hold"],
  [ProductTestStatus.DirectShip, "Direct Ship"],
  [ProductTestStatus.Rejected, "Rejected"],
])

export const PRODUCT_TEST_STATUS_TO_COLOR = new Map<string, string>([
  [ProductTestStatus.Approved, colors.tertiary.green["100"]],
  [ProductTestStatus.OnHold, colors.tertiary.orange["100"]],
  [ProductTestStatus.DirectShip, colors.tertiary.purple["100"]],
  [ProductTestStatus.Rejected, colors.secondary["100"]],
])

export const PRODUCT_TEST_DOCUMENT_TYPES: FieldGroupEnum[] = [
  FieldGroupEnum.ProductCoa,
  FieldGroupEnum.ProductCoo,
  FieldGroupEnum.ProductLabwork,
  FieldGroupEnum.Miscellaneous,
  FieldGroupEnum.ProductSds,
  FieldGroupEnum.ProductTds,
]

export const PRODUCT_TEST_DOCUMENT_TYPE_TO_LABEL: Partial<Record<FieldGroupEnum, string>> = {
  [FieldGroupEnum.ProductCoa]: "COA",
  [FieldGroupEnum.ProductCoo]: "COO",
  [FieldGroupEnum.ProductLabwork]: "Labwork",
  [FieldGroupEnum.Miscellaneous]: "Miscellaneous",
  [FieldGroupEnum.ProductSds]: "SDS",
  [FieldGroupEnum.ProductTds]: "TDS",
}

export const PRODUCT_TEST_DOCUMENT_TYPE_TO_COLOR: Partial<Record<FieldGroupEnum, string>> = {
  [FieldGroupEnum.ProductCoa]: colors.tertiary.purple["100"],
  [FieldGroupEnum.ProductCoo]: colors.secondary["200"],
  [FieldGroupEnum.ProductLabwork]: colors.tertiary.yellow["100"],
  [FieldGroupEnum.Miscellaneous]: colors.tertiary.green["300"],
  [FieldGroupEnum.ProductSds]: colors.primary["200"],
  [FieldGroupEnum.ProductTds]: colors.tertiary.orange["300"],
}

// Derived from the label/color lookups above rather than duplicating the same values a third time.
export const PRODUCT_TEST_DOCUMENT_TYPE_TO_CHIP: FileTypeToChipMap = PRODUCT_TEST_DOCUMENT_TYPES.reduce(
  (chipMap, type) => ({
    ...chipMap,
    [type]: { label: PRODUCT_TEST_DOCUMENT_TYPE_TO_LABEL[type]!, color: PRODUCT_TEST_DOCUMENT_TYPE_TO_COLOR[type]! },
  }),
  {} as FileTypeToChipMap
)

export const PRODUCT_TEST_RESULT_PASS_FAIL_TO_LABEL = new Map<string, string>([
  [ProductTestResultPassFail.Pass, "Pass"],
  [ProductTestResultPassFail.Fail, "Fail"],
])

export const PRODUCT_TEST_RESULT_YES_NO_TO_LABEL = new Map<string, string>([
  [ProductTestResultYesNo.Yes, "Yes"],
  [ProductTestResultYesNo.No, "No"],
])
